"use client";

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { SupportedGames } from "@/types/game";
import { setLastVisitedGame, setPreferenceAsked } from "@/lib/lastGameStore";
import { getGame } from "@/games";

interface GamePreferenceModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentGame: SupportedGames;
}

export default function GamePreferenceModal({
  isOpen,
  onClose,
  currentGame,
}: GamePreferenceModalProps) {
  const game = getGame(currentGame);

  const handleSavePreference = () => {
    setLastVisitedGame(currentGame);
    setPreferenceAsked();
    onClose();
  };

  const handleNotNow = () => {
    setPreferenceAsked();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} backdrop="blur" size="md">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          Set {game.name} as your default game?
        </ModalHeader>
        <ModalBody>
          <p className="text-gray-300">
            Would you like to save {game.name} as your preferred game? Next time
            you visit TCGfan.com, we'll take you directly to {game.name}{" "}
            content.
          </p>
          <p className="text-sm text-gray-400 mt-2">
            You can always change this later or switch games using the game
            selector.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={handleNotNow}>
            Not now
          </Button>
          <Button color="primary" onPress={handleSavePreference}>
            Save as default
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
